import { SubscriptionInterval } from 'constants/order';
import type { ProductType } from './product';
import { CartBundle } from 'contexts/type/cart-type';
import { PetType } from 'constants/pet-type';

export type PdProductItem = BasicPdProductItem | PdSubscriptionProductItem | GiftProductItem;

export interface ItemDiscount {
  amount: number;
  originIndex: number;
}

export interface BasicPdProductItem {
  // BE still contains legacy orders/subscriptions created when `variantId` was a number.
  // PDEX now uses string IDs. To stay compatible with legacy data, we serialize `variantId`
  // as a string in BE responses. In request payloads to BE based on current contract it is being used as number
  variantId: number;
  productId: number;
  /** @deprecated Same value as variantId. use variantId instead */
  masterVariantId: number;
  masterProductId: string;
  productTitle: string;
  variantTitle: string;
  productType: ProductType;
  quantity: number;
  /** Price with subscribe discount by coupon and subscribe discount considered (including Ninetailed personalization) */
  price: number;
  handle?: string;
  /** Default price without any discount */
  defaultPrice: number;
  imageSrc?: string;
  title: string;
  taxRatios: Array<[number, number]>;
  sku: string;
  tags: string;
  /** Weight in grams */
  grams: number;
  /** This is present if the item is calculated based on experiment variant specified optimize headers. Debug purpose only */
  pricingVariant?: string;
  /** True if this item is subscribable */
  subscribable: boolean;
  /** Compared at price to show the strike price. Usually only valid for bundles */
  compareAtPrice?: number;
  /** First subscription discount percentage value. e.g 10 -> 10% discount */
  subscriptionDiscount?: number;
  /** Discounted price after first order. which means 10% discount default */
  subscriptionPrice?: number;
  /** Amount sum of discounted price */
  discountReduction: number;
  /** Array of discounts applied to this item with reference to discountOrigins */
  discounts?: ItemDiscount[];
  /** Savings plan discount percentage value. e.g 5 -> 5% discount */
  savingsPlanDiscount?: number;
  /** Discounted price with savings plan applied */
  savingsPlanPrice?: number;
  bundleRefs?: CartBundle[];
  petType?: PetType;
}

/** @TODO : add comment item interface when it's in Subscription  */
export interface PdSubscriptionProductItem extends BasicPdProductItem {
  compareAtPrice: number;
  /** like  "4week" */
  interval: SubscriptionInterval;
  /** Reduced price for subscription with Ninetailed personalization considered (i.e global discount)*/
  subscriptionPrice: number;
}

export function isSubscriptionItem(item): item is PdSubscriptionProductItem {
  return typeof item.interval === 'string' && item.interval !== '';
}

export interface GiftProductItem extends BasicPdProductItem {
  /** This is present When item is redeem for points and if not, this is zero.*/
  points: number;
  /** True when item is added as a redemption gift */
  redeemItem: boolean;
}

export function isGiftProductItem(item): item is GiftProductItem {
  return (
    typeof item !== 'undefined' && item.redeemItem === true && item.points > 0 && item.price === 0
  );
}
